/**
 * PlanTypeToggle Component
 *
 * Toggle between Individual and Family (5 members) plans
 */
import { View, Text, Pressable } from "react-native";
import { useTranslation } from "@dramadetector/shared";

type PlanType = 'individual' | 'family';

interface PlanTypeToggleProps {
  planType: PlanType;
  onPlanTypeChange: (planType: PlanType) => void;
}

export function PlanTypeToggle({ planType, onPlanTypeChange }: PlanTypeToggleProps) {
  const { t } = useTranslation('subscription');
  return (
    <View className="flex-row justify-center my-4 px-4">
      <View className="flex-row bg-gray-100 rounded-full p-1">
        <Pressable
          onPress={() => onPlanTypeChange('individual')}
          className={`px-6 py-2 rounded-full ${
            planType === 'individual' ? 'bg-white shadow-sm' : 'bg-transparent'
          }`}
        >
          <Text className={`font-semibold ${
            planType === 'individual' ? 'text-gray-900' : 'text-gray-500'
          }`}>
            {t('plan_types.individual')}
          </Text>
        </Pressable>
        <Pressable
          onPress={() => onPlanTypeChange('family')}
          className={`px-6 py-2 rounded-full ${
            planType === 'family' ? 'bg-white shadow-sm' : 'bg-transparent'
          }`}
        >
          <Text className={`font-semibold ${
            planType === 'family' ? 'text-gray-900' : 'text-gray-500'
          }`}>
            {t('plan_types.family')}
          </Text>
        </Pressable>
      </View>
    </View>
  );
}
